import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  documentName = 'dynamic_product';

  constructor(private _httpClient: HttpClient) { }

  getListProductbyIds(ids: any[]): Observable<any> {
    return this._httpClient.post('/dynamic-documents/dynamic_product/ids', ids).pipe(map((res: any) => res));
  }
}
